import React from 'react';
import {STYLES} from 'core/constants/uiConstants';
import {usePCTranslation} from 'core/hooks';

const TooltipText = ({ name, tooltipInput }) => {
  const { t } = usePCTranslation();

  const generateTooltipContent = () => {
    if (tooltipInput?.length) {
      const tooltipElements = [];
      tooltipInput.forEach((tt) => {
        const ele = <div>{tt}</div>;
        tooltipElements.push(ele);
      });
      return tooltipElements;
    }
    return <span>{t(`${name}-tooltip`)}</span>;
  };
  return (
    <div className={`${STYLES.TOOLTIPTEXT}`} name={name}>
      {generateTooltipContent()}
    </div>
  );
};

export default TooltipText;
